import React from 'react';
import { Scatter } from 'react-chartjs-2';
import './chartSetup';
import { useThemeMode } from '../theme';
import { buildScatter } from './builders';
import { themePalette } from './palette';

// Scatter chart. `points` from charts.preparePoints
// [{ x, y, series? }]; xLabel/yLabel are the field keys for axis titles.
export default function ScatterViz({ points, xLabel, yLabel }) {
  useThemeMode();
  const { data, options } = buildScatter(points, xLabel, yLabel, themePalette());
  return <Scatter data={data} options={options} />;
}
